import React from "react"
import { Field } from "redux-form"
import styles from "./styles.scss"
import cx from "classnames"

class FieldWrapper extends React.Component {
  render() {
    const { name, label, className, ...rest } = this.props
    return (
      <div className={cx(styles.container, className)}>
        <label className={styles.label} htmlFor={name}>{label} </label>
        <Field name={name} {...rest} />
      </div>
    )
  }
}

export default FieldWrapper



// WEBPACK FOOTER //
// src/components/FieldWrapper/index.jsx